export const SET_PAGE_STATE = 'SET_PAGE_STATE';

export const USER_INFO_DEPENDENCY = 'userInfo';
export const CREDIT_INFO_DEPENDENCY = 'CREDIT_INFO';
export const CONFIG_DEPENDENCY = 'config';
export const SESAME_CASH_DEPENDENCY = 'sesameCash';
export const FEATURED_ADS_DEPENDENCY = 'featuredAd';
